import { Button, Drawer, Icons, Show, Tabs, Typography } from "@pankod/refine-antd";
import { IResourceComponentsProps, useOne, useCan } from "@pankod/refine-core";
import { RenderAudioPlayer, RenderLocalAudioPlayer } from "components/common";
import dayjs from "dayjs";
import { OutreachForm } from "components/common";
import { IInfoPagesMetadata } from "interfaces";
import React, { useState } from "react";
import { DATAPROVIDER_LOOKUP, isValidUrl, RESOURCE_PATH } from "scripts/site";

export const PodcastList: React.FC<IResourceComponentsProps> = () => {

    const { data: metadata, isLoading: metadataLoading } = useOne<IInfoPagesMetadata>({
        dataProviderName: DATAPROVIDER_LOOKUP,
        resource: RESOURCE_PATH.METADATA,
        id: RESOURCE_PATH.INFO_PODCAST,
        queryOptions: {
            enabled: true,
            staleTime: 300000
        }
    });
    const entityMetadata = metadata?.data;
    const { Title, Text } = Typography;
    const [outreachOpen, switchOutreach] = useState(false);
    const canListExpertOutreach = useCan({
        resource: RESOURCE_PATH.EXPERT_OUTREACH,
        action: "create"
    });

    const getTabs = () => {
        let tabs: any[] = [];
        entityMetadata?.fields?.map((m, i) => (
            tabs.push(
                {
                    label: m.name,
                    key: i,
                    children: <>
                        <Title level={5}>Author</Title>
                        <Text>{m.author}</Text>
                        <Title level={5}>Summary</Title>
                        <Text>{m.summary}</Text>
                        <Title level={5}>Publicaton Date</Title>
                        <Text>{dayjs(m.pubDate).format("LL") ?? "---"}</Text>
                        <Title level={5}>Listen to this Podcast</Title>
                        {isValidUrl(m.attachment) ?
                            <RenderAudioPlayer audioFilePath={m.attachment} />
                            :
                            <RenderLocalAudioPlayer audioFilePath={m.attachment} resourceName={RESOURCE_PATH.INFO_PODCAST} />
                        }
                    </>
                })
        ));
        return tabs;
    }

    return (
        <Show
            isLoading={metadataLoading}
            headerProps={{
                title: entityMetadata?.config?.pageHeading,
                extra: canListExpertOutreach.data?.can && entityMetadata?.config?.connectButtonText &&
                    <Button key="help" onClick={() => switchOutreach(true)} icon={<Icons.ReadOutlined />}>{entityMetadata?.config?.connectButtonText}</Button>
            }}
        >
            <Tabs
                tabPosition="left"
                items={getTabs()}
            />
            {canListExpertOutreach.data?.can &&
                <Drawer
                    title={entityMetadata?.config?.drawerTitle}
                    placement="right"
                    size={entityMetadata?.config?.drawerFormSize}
                    open={outreachOpen}
                    onClose={() => { switchOutreach(false) }}
                >
                    <OutreachForm categoryType={entityMetadata?.config?.connectCategory} onFormSubmit={() => switchOutreach(false)} />
                </Drawer>
            }
        </Show>
    );
};
